import { useEffect } from 'react';
import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";
import { routes } from './routes/routes';
import { useSelector } from 'react-redux'
import "react-toastify/dist/ReactToastify.css";
import SplashScreen from './components/SplashScreen/SplashScreen';
import useAuthSync from './hooks/useAuthSync';

const router = createBrowserRouter(routes)

function App() {
  useAuthSync();
  const loading = useSelector((state) => state.auth.loading);

  // Passenger Portal Subdomain Redirection
  useEffect(() => {
    const isPassengerDomain = window.location.hostname.startsWith('mi.') || window.location.hostname.includes('mi.rutamundial');
    if (isPassengerDomain && window.location.pathname === '/') {
      window.location.replace('/mi-viaje');
    }
  }, []);

   if (loading) {
    return <SplashScreen />;
  }

  return (
      <RouterProvider
        router={router}
      />
  );
}


export default App;
